import React from "react";
import ContractHoldersHeaderOptions from "./HeaderOptions.jsx";
import ContractHoldersHeaderGroupOptions from "./HeaderGroupOptions.jsx";

export default function ContractHoldersHeader({
  contractHoldersGroups,
  options,
  setOptions,
  searchType,
  setSearchType,
  searchValue,
  setSearchValue,
}) {
  return (
    <div className="contract-holders-header">
      <h1 className="page_title">NASA SEWP Contract Holders</h1>
      <ContractHoldersHeaderOptions
        options={options}
        setOptions={setOptions}
        searchType={searchType}
        setSearchType={setSearchType}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <ContractHoldersHeaderGroupOptions
        contractHoldersGroups={contractHoldersGroups}
        options={options}
        setOptions={setOptions}
      />
    </div>
  );
}
